import { Vue, Component, Prop } from 'vue-property-decorator'
import { api } from '@/galaxy-cruise/api';
import { store } from '@/store';
import { reloadSession, goNextGalaxy } from '@/galaxy-cruise/utils';

@Component
export default class extends Vue {
  async redoTraining() {
    this.$emit('resolve')
    const axios = api.default
    await axios.post('../api/v1/answers/clear', { series: 'training' })
    await reloadSession()
    await goNextGalaxy(5000)
  }

  async goAhead() {
    this.$emit('resolve')
    this.gc.series = 'season_1'
    await reloadSession()
    await goNextGalaxy(5000)
  }

  get gc() {
    return store.galaxyCruise
  }
}
